export const renalDetectFeatureKey = 'renalDetect';
